(() => {
  const topic = document.querySelector('#ContactTopic');
  if (topic) {
    const requested = new URLSearchParams(location.search).get('topic');
    if ([...topic.options].some(option => option.value === requested)) topic.value = requested;
  }
  const root = document.querySelector('.shopify-policy__container');
  const body = root?.querySelector('.shopify-policy__body');
  if (!body || root.dataset.enhanced) return;
  root.dataset.enhanced = 'true';
  const layout = document.createElement('div'); layout.className = 'policy-reading-layout';
  body.before(layout); layout.append(body);
  const nav = document.createElement('nav'); nav.className = 'policy-page-nav'; nav.setAttribute('aria-label', 'Policy navigation');
  const title = document.createElement('strong'); title.textContent = 'ON THIS PAGE'; nav.append(title);
  const headings = [...body.querySelectorAll('h2,h3,h4,p')].filter(el => /^H[234]$/.test(el.tagName) || (el.children.length === 1 && /^(STRONG|B)$/.test(el.firstElementChild.tagName) && /^\d+[.\s]/.test(el.textContent.trim()) && el.textContent.length < 140));
  headings.forEach((heading, index) => {
    if (!heading.id) heading.id = `policy-section-${index + 1}`;
    if (heading.tagName === 'P') { heading.classList.add('policy-section-heading'); heading.setAttribute('role','heading'); heading.setAttribute('aria-level','2'); }
    const link = document.createElement('a'); link.href = `#${heading.id}`; link.textContent = heading.textContent.trim(); nav.append(link);
  });
  if (!headings.length) title.textContent = 'POLICIES & HELP';
  const related = document.createElement('div'); related.className = 'policy-related';
  const seen = new Set();
  document.querySelectorAll('footer a[href*="/policies/"]').forEach(source => {
    if (seen.has(source.pathname) || source.pathname === location.pathname) return;
    seen.add(source.pathname); const link = document.createElement('a'); link.href = source.href; link.textContent = source.textContent.trim(); related.append(link);
  });
  const help = document.createElement('a'); help.href = '/pages/faq'; help.textContent = 'Help Center '; related.append(help); nav.append(related); layout.prepend(nav);
  body.querySelectorAll('table').forEach(table => { const wrap = document.createElement('div'); wrap.className = 'policy-table-wrap'; wrap.tabIndex = 0; wrap.setAttribute('role','region'); wrap.setAttribute('aria-label','Policy details table'); table.before(wrap); wrap.append(table); });
})();
